import './inc/style';
import 'regenerator-runtime/runtime';
import 'core-js/stable';

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

import "photoswipe/style.css";

(($) => {
    document.addEventListener('DOMContentLoaded', () => {

        $('#search-button-toggle').on('click', function(e) {
            e.preventDefault()
            $('body').toggleClass('search-open')
            $(this).toggleClass('open')
        })    


        const lightbox = new PhotoSwipeLightbox({
            gallery: '#product-gallery',
            children: 'figure',
            pswpModule: () => PhotoSwipe,
        });
    
        lightbox.init();

    });
})(jQuery);
